import { useEffect, useState } from 'react';
import BrowserPanel from './panels/BrowserPanel';

/**
 * Unsichtbares Hintergrund-Fenster mit Rafaels Standard-Cookies (Rafael 03.10.2026,
 * Buehne b-hintergrund-fenster-gleiche-cookies-20261003, Antwort a).
 *
 * Ein Buehnen-Fenster lebt nur, solange seine Buehne offen ist; wechselt Rafael die
 * Buehne, wird es abgebaut und kein Befehl kommt mehr an (gemessen 03.10.2026, 10:34Z:
 * Keyword-Planer-Fenster ohne Antwort). Dieses Fenster haengt an der App selbst und
 * bleibt geladen, egal was vorne ist. Es teilt den Cookie-Speicher der Buehnen-Fenster
 * (rafael-standard), die Anmeldungen gelten also auch hier.
 *
 * Steuerbar ueber die normale Browser-Panel-API unter der Kennung `#hintergrund-browser`.
 * Nur im Desktop-Programm: Die Cookies liegen dort, und der Schatten-Client auf dem
 * Server ist absichtlich nicht angemeldet.
 *
 * Die Kachel liegt IM Sichtbereich, aber voll durchsichtig und hinter allem. Ausserhalb
 * (left:-20000) luden Seiten zwar, aber Tabellen mit Nachlade-Logik zeichneten keine Zeilen:
 * sie warten, bis ihr Bereich den Sichtbereich schneidet (gemessen 03.10.2026 am
 * Keyword-Planer, „1 bis 12 von 12“ ohne eine einzige Zeile im DOM). display:none
 * scheidet aus demselben Grund aus.
 */
export const HINTERGRUND_BROWSER_ID = '#hintergrund-browser';

export default function HintergrundBrowser() {
  const [clientId, setClientId] = useState<string | undefined>(undefined);
  const desktop = !!window.electronAPI?.isElectron;
  const schatten = new URLSearchParams(window.location.search).get('shadow') === '1';

  // Die Besitzmeldung (/browser-panel/ready) braucht die Client-Kennung aus dem
  // WS-Hallo. Sie kommt erst nach dem Start und wechselt bei jeder Neuverbindung;
  // die Kachel wird dann neu eingehaengt und meldet sich unter der neuen Kennung.
  useEffect(() => {
    if (!desktop || schatten) return;
    const lesen = () => setClientId((window as unknown as { __CUI_CLIENT_ID__?: string }).__CUI_CLIENT_ID__);
    lesen();
    const uhr = setInterval(lesen, 2000);
    return () => clearInterval(uhr);
  }, [desktop, schatten]);

  if (!desktop || schatten || !clientId) return null;
  return (
    <div
      aria-hidden
      data-hintergrund-browser
      style={{ position: 'fixed', left: 0, top: 0, width: 1400, height: 900, opacity: 0, zIndex: -1, pointerEvents: 'none' }}
    >
      <BrowserPanel key={clientId} panelId={HINTERGRUND_BROWSER_ID} />
    </div>
  );
}
